import { render } from "./TyreCard.vue?vue&type=template&id=327f39c0"
import script from "./TyreCard.vue?vue&type=script&lang=js"
export * from "./TyreCard.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__